import React, { useEffect } from 'react';
import SEO from '../components/SEO';
import GetSEOData from '../data/SEO';
import { useStaticQuery, graphql } from 'gatsby';
import LitImage from '../components/images/LitImage';
import EventTracker, {
  HomepageEvent,
} from '../components/tracking/EventTracker';
import AnyQuestions from '../components/AnyQuestions';
import { Cookies } from 'react-cookie-consent';
import { ReferralCodeCookie } from '../data/Cookies';
import HomeHero from '../components/HomeHero';
import CustomerReviewCarousel from '../components/CustomerReviewCarousel';
import ModularImageHeaderParagraph from '../components/ModularImageHeaderParagraph';
import ImageBannerCarousel from '../components/ImageBannerCarousel';
import ModularBlogNewsCarousel from '../components/ModularBlogNewsCarousel';
import ModularProductCards from '../components/ModularProductCards';
import ModularImageSecondaryImage from '../components/ModularImageSecondaryImage';
import ModularHeadingContentImageButton from '../components/ModularHeadingContentImageButton';
import ModularImageBody from '../components/ModularImageBody';
import ModularHeadingPaths from '../components/ModularHeadingPaths';
import ModularFaqs from '../components/ModularFaqs';
const IndexPage = ({ location }) => {
  let { title, description } = GetSEOData('index');
  const data = imageQuery();
  const homepageData = data.allDatoCmsHomepageModel.nodes[0];
  const { modularHomepageContent } = homepageData;

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const campaignSource = params.get('utm_source');
    const campaignValue = params.get('utm_campaign');
    if (
      campaignSource?.toLowerCase() === 'leave behind cards' &&
      campaignValue
    ) {
      Cookies.set(ReferralCodeCookie, btoa(campaignValue), {
        expires: 1,
      });
    }
  }, [location]);

  const GetHomepageModularComponent = (type, data) => {
    switch (type) {
      case 'DatoCmsHomeHeroBlock':
        return <HomeHero data={data} />;
      case 'DatoCmsImageHeaderParagraph':
        return <ModularImageHeaderParagraph data={data} />;
      case 'DatoCmsHeadingContentImageButtonBlock':
        return <ModularHeadingContentImageButton data={data} />;
      case 'DatoCmsImageBannerCarousel':
        return <ImageBannerCarousel data={data} />;
      case 'DatoCmsCustomerReviewBlock':
        return <CustomerReviewCarousel data={data} />;
      case 'DatoCmsBlogAndNewsCarousel':
        return <ModularBlogNewsCarousel data={data} />;
      case 'DatoCmsProductCardsBlock':
        return <ModularProductCards data={data} />;
      case 'DatoCmsImageSecondaryImageBlock':
        return <ModularImageSecondaryImage data={data} />;
      case 'DatoCmsImageBodyBlock':
        return <ModularImageBody data={data} />;
      case 'DatoCmsHeadingPathGroupBlock':
        return <ModularHeadingPaths data={data} />;
      case 'DatoCmsModularFaq':
        return <ModularFaqs data={data} />;
    }
  };

  return (
    <div className="modular-homepage-container">
      <LitImage image={data.stars} alt="" />
      <SEO
        title={homepageData.seo.title}
        description={homepageData.seo.description}
        metaTags={homepageData.seo}
      />
      {modularHomepageContent.map((component) => {
        return GetHomepageModularComponent(component.internal.type, component);
      })}
      <EventTracker eventNumber={HomepageEvent} />
    </div>
  );
};

export default IndexPage;

const imageQuery = () =>
  useStaticQuery(graphql`
    {
      allDatoCmsHomepageModel {
        nodes {
          seo {
            description
            title
            twitterCard
            image {
              gatsbyImageData
            }
          }
          modularHomepageContent {
            ...ModularHomeHero
            ...ModularHeadingContentImageButton
            ...ModularCustomerReviewCarousel
            ...ModularProductCards
            ...ModularImageBannerCarousel
            ...ModularImageHeaderParagraph
            ...ModularImageSecondaryImage
            ...ModularImageBody
            ...ModularHeadingPaths
            ...ModularFaqs
          }
        }
      }
    }
  `);
